import { Mixpanel } from './mixPanel'
import { IUserType } from '../../interfaces/user.interface'

const identifyUser = (opts: {
  userId: string
  userType: IUserType
  email: string
  firstName: string
  lastName: string
}) => {
  try {
    Mixpanel.identify(opts.userId)
    Mixpanel.people.set({
      $first_name: opts.firstName,
      $last_name: opts.lastName,
      $email: opts.email,
      student: opts.userType === 'student',
      teacher: opts.userType === 'teacher',
      admin: opts.userType === 'admin',
      account_user: opts.userType === 'account_user',
    })
  } catch (err) {
    console.log('Error in mixpanel', err)
  }
}

const onPledreHomepageVisit = (data?: any) => {
  try {
    Mixpanel.track('Pledre Homepage Visit', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onSchoolVisit = (data?: any) => {
  try {
    Mixpanel.track('School Visit', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminSignupSelected = (data?: any) => {
  try {
    Mixpanel.track('Admin signup selected', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminLoginSelected = (data?: any) => {
  try {
    Mixpanel.track('Admin login selected', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onPledreSSOUse = (data?: {
  continueUrl: string
  loginWith?: string
  schoolAuthId: string
  userType: string
  errors?: {
    error: boolean
    message?: string
  }
}) => {
  try {
    Mixpanel.track('Pledre Auth/SSO Use', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onUserSignup = (opts: {
  userId: string
  email: string
  firstName: string
  lastName: string
  data?: any
  userType: IUserType
}) => {
  try {
    Mixpanel.alias(opts.userId)
    Mixpanel.alias(opts.email)
    Mixpanel.people.set({
      $first_name: opts.firstName,
      $last_name: opts.lastName,
      $email: opts.email,
      student: opts.userType === 'student',
      teacher: opts.userType === 'teacher',
      admin: opts.userType === 'admin',
      account_user: opts.userType === 'account_user',
    })
    Mixpanel.track('User signup success', { ...opts.data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onUserLogin = (opts: {
  userId: string
  email: string
  firstName: string
  lastName: string
  userType: IUserType
  data?: any
}) => {
  try {
    Mixpanel.alias(opts.email)
    Mixpanel.identify(opts.userId)
    Mixpanel.people.set({
      $first_name: opts.firstName,
      $last_name: opts.lastName,
      $email: opts.email,
      student: opts.userType === 'student',
      teacher: opts.userType === 'teacher',
      admin: opts.userType === 'admin',
      account_user: opts.userType === 'account_user',
    })
    Mixpanel.track('Admin login success', { ...opts.data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminDashboardViewed = (data?: any) => {
  try {
    Mixpanel.track('Admin dashboard view', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCreateSchoolClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin create school clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminSchoolClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin school clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminSchoolCreatedSuccess = (data?: any) => {
  try {
    Mixpanel.track('Admin school created', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCreateCourseClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin create course clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCreateCourseClosed = (data?: any) => {
  try {
    Mixpanel.track('Admin create course closed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseCreated = (data?: any) => {
  try {
    Mixpanel.track('Admin course created', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseDetailsSubmitted = (data?: any) => {
  try {
    Mixpanel.track('Admin course details submitted', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin course clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseSettingClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin course settings clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseShareClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin course share clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}
const onAdminClusterShareClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin cluster share clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseStudentsClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin course students clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminUpgradeSchoolSelected = (data?: any) => {
  try {
    Mixpanel.track('Admin upgrade school selected', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminUpgradeSchoolBillingPlanSelected = (
  planName: string,
  data?: any,
) => {
  try {
    Mixpanel.track('Admin upgrade school billing plan selected', {
      planName: planName,
      ...data,
    })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminUpgradeSchoolSubscriptionPageView = (data?: any) => {
  try {
    Mixpanel.track('Admin upgrade school page view', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminUpgradeSchoolSuccessful = (data?: any) => {
  try {
    Mixpanel.track('Admin upgrade school subscription success', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminHubspotDialogOpened = (data?: any) => {
  try {
    Mixpanel.track('Admin hubspot dialog opened', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminUpgradeSchoolApplyDiscount = (data?: any) => {
  try {
    Mixpanel.track('Admin upgrade school apply discount clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminExpertFormClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin expert form clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminDiscountFormClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin discount form clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseContentCreatedSuccess = (data?: any) => {
  try {
    Mixpanel.track('Admin course content created success', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseLessonCreatedSuccess = (data?: any) => {
  try {
    Mixpanel.track('Admin course lesson created success', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCreateCourseContentClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin course content created clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCreateCourseLessonClicked = (data?: any) => {
  try {
    Mixpanel.track('Admin course lesson created clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseTemplateSelected = (data?: any) => {
  try {
    Mixpanel.track('Admin course content template selected', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseTemplateOpened = (data?: any) => {
  try {
    Mixpanel.track('Admin course content template opened', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseTemplatePreview = (data?: any) => {
  try {
    Mixpanel.track('Admin course content template previewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCourseTemplateClosed = (data?: any) => {
  try {
    Mixpanel.track('Admin course content template closed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminUserLogout = (data?: any) => {
  try {
    Mixpanel.track('Admin user logout', { ...data })
    Mixpanel.reset()
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onSchoolUserLogout = (data?: any) => {
  try {
    Mixpanel.track('School user logout', { ...data })
    Mixpanel.reset()
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onUserAutomatedLogout = (reason: string, data?: any) => {
  try {
    Mixpanel.track('User automated logout', { reason, ...data })
    Mixpanel.reset()
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminLoginError = (errorMessage: string, data?: any) => {
  try {
    Mixpanel.track('Login unsuccessful', { message: errorMessage, ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminSignupError = (errorMessage: string, data?: any) => {
  try {
    Mixpanel.track('Signup unsuccessful', { message: errorMessage, ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onCouponPageView = (data?: any) => {
  try {
    Mixpanel.track('Coupon page view', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onCreatorSuiteSelected = (data?: any) => {
  try {
    Mixpanel.track('Creator Suite Selected', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

const onRecordVideoSelected = (data?: any) => {
  try {
    Mixpanel.track('Video Recording Selected', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

const onImportYoutubeVideoSelected = (data?: any) => {
  try {
    Mixpanel.track('Video Recording Selected', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

const onVideoRecordingStarted = (data?: any) => {
  try {
    Mixpanel.track('Video Recording Started', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

const onVideoRecordingSuccessful = (data?: any) => {
  try {
    Mixpanel.track('Video Recording Sucessful', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

const onVideoRecordingSaved = (data?: any) => {
  try {
    Mixpanel.track('Video Recording Saved', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

const onUploadItemStarted = (data?: any) => {
  try {
    Mixpanel.track('Item Upload Started', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}
const onUploadItemSuccessful = (data?: any) => {
  try {
    Mixpanel.track('Item Upload Sucessful', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}
const onMyCourseClicked = (data?: any) => {
  try {
    Mixpanel.track('My course clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onCreateCouponClicked = (data?: any) => {
  try {
    Mixpanel.track('CreateCoupon clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onCouponAppliedSuccessfully = (data?: any) => {
  try {
    Mixpanel.track('CouponApply clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const openCourseClicked = (data?: any) => {
  try {
    Mixpanel.track('Open course clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}
const userDashboardViewed = (data?: any) => {
  try {
    Mixpanel.track('User dashboard viewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}
const courseContentClicked = (data?: any) => {
  try {
    Mixpanel.track('courseContent clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const assessmentClicked = (data?: any) => {
  try {
    Mixpanel.track('Assessment clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const assessmentAttemptClicked = (data?: any) => {
  try {
    Mixpanel.track('Assessment attempt clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}
const assessmentViewedClicked = (data?: any) => {
  try {
    Mixpanel.track('Assessment attempt clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const assessmentAttempted = (data?: any) => {
  try {
    Mixpanel.track('Assessment attempted', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const assessmentViewed = (data?: any) => {
  try {
    Mixpanel.track('Assessment viewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const activeChatClicked = (data?: any) => {
  try {
    Mixpanel.track('Active chat clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const activeChatViewed = (data?: any) => {
  try {
    Mixpanel.track('Active chat viewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const searchForUser = (data?: any) => {
  try {
    Mixpanel.track('Search for user', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const userSelectedFromSearch = (data?: any) => {
  try {
    Mixpanel.track('userSelectedForSearch', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onCouponCreatedSuccesfully = (data?: any) => {
  try {
    Mixpanel.track('Coupon Created Sucessfully', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const chatViewedForSchoolUser = (data?: any) => {
  try {
    Mixpanel.track('chatViewedForSchoolUser', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onViewCouponClicked = (data?: any) => {
  try {
    Mixpanel.track('view coupon clicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}
const chatTypingForSchoolUser = (data?: any) => {
  try {
    Mixpanel.track('chatTypingForSchoolUser', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const chatSent = (data?: any) => {
  try {
    Mixpanel.track('chatSent', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onEditCoupon = (data?: any) => {
  try {
    Mixpanel.track('Coupon Edited', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}
const adminChangeSidebarContentClicked = (data?: any) => {
  try {
    Mixpanel.track('adminChangeSidebarContentClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onDeleteCoupon = (data?: any) => {
  try {
    Mixpanel.track('Coupon Deleted', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}
const forumDiscussionClicked = (data?: any) => {
  try {
    Mixpanel.track('forumDiscussionClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const forumDiscussionViewed = (data?: any) => {
  try {
    Mixpanel.track('forumDiscussionViewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const createdDiscussionClicked = (data?: any) => {
  try {
    Mixpanel.track('createdDiscussionClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const createdDiscussionViewed = (data?: any) => {
  try {
    Mixpanel.track('createdDiscussionViewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const publicDiscussionViewed = (data?: any) => {
  try {
    Mixpanel.track('publicDiscussionViewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const publishDiscussionClicked = (data?: any) => {
  try {
    Mixpanel.track('publishDiscussionClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const publishDiscussionSuccessful = (data?: any) => {
  try {
    Mixpanel.track('publishDiscussionSuccessful', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const billingClicked = (data?: any) => {
  try {
    Mixpanel.track('billingClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const billingViewed = (data?: any) => {
  try {
    Mixpanel.track('billingViewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const paymentInitiated = (data?: any) => {
  try {
    Mixpanel.track('paymentInitiated', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const paymentSuccessful = (data?: any) => {
  try {
    Mixpanel.track('paymentSuccessful', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}
const scheduledViewed = (data?: any) => {
  try {
    Mixpanel.track('scheduledViewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const scheduledClicked = (data?: any) => {
  try {
    Mixpanel.track('scheduledClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const viewCurriculum = (data?: any) => {
  try {
    Mixpanel.track('viewCurriculum', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const openClassroomClicked = (data?: any) => {
  try {
    Mixpanel.track('openClassroomClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const classroomViewed = (data?: any) => {
  try {
    Mixpanel.track('classroomViewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const contentClicked = (data?: any) => {
  try {
    Mixpanel.track('contentClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const contentViewed = (data?: any) => {
  try {
    Mixpanel.track('contentViewed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const dialogOpened = (data?: any) => {
  try {
    Mixpanel.track('dialogOpened', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const dialogClosed = (data?: any) => {
  try {
    Mixpanel.track('dialogClosed', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassClicked = (data?: any) => {
  try {
    Mixpanel.track('liveClassClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassJoined = (data?: any) => {
  try {
    Mixpanel.track('liveClassJoined', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassLeft = (data?: any) => {
  try {
    Mixpanel.track('liveClassClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const clickLeaveClass = (data?: any) => {
  try {
    Mixpanel.track('liveClassClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const toggleLiveClassDialog = (data?: any) => {
  try {
    Mixpanel.track('toggleLiveClassDialog', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassInitiated = (data?: any) => {
  try {
    Mixpanel.track('liveClassInitiated', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassStarted = (data?: any) => {
  try {
    Mixpanel.track('liveClassStarted', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassToggleAttendees = (data?: any) => {
  try {
    Mixpanel.track('liveClassOpenAttendees', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassToggleChat = (data?: any) => {
  try {
    Mixpanel.track('liveClassOpenAttendees', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassRecordingClicked = (data?: any) => {
  try {
    Mixpanel.track('liveClassRecordingClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const creatorSuiteRecordingStarted = (data?: any) => {
  try {
    Mixpanel.track('creatorSuiteRecordingStarted', { ...data })
  } catch (error) {
    console.log('Error in mixpanel', error)
  }
}

const creatorSuiteRecordingStopped = (data?: any) => {
  try {
    Mixpanel.track('creatorsuiteRecordingStopped', { ...data })
  } catch (error) {
    console.log('Error in mixpanel', error)
  }
}

const liveClassSendChatMessage = (data?: any) => {
  try {
    Mixpanel.track('liveClassSendChatMessage', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassStopMeetingClicked = (data?: any) => {
  try {
    Mixpanel.track('liveClassStopMeetingClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const liveClassRaiseHandClicked = (data?: any) => {
  try {
    Mixpanel.track('liveClassRaiseHandClicked', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onForgotPassword = (data?: any) => {
  try {
    Mixpanel.track('On forgot password', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onCreateNewPassword = (data?: any) => {
  try {
    Mixpanel.track('onCreateNewPassword', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onEditCourseContent = (data?: any) => {
  try {
    Mixpanel.track('Course Content Edited', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onHighlightBannerClicked = (data?: any) => {
  try {
    Mixpanel.track('Promo HighlightBanner Clicked', { ...data })
  } catch (error) {
    console.log('Error in mixpanel', error)
  }
}

const onHighlightBannerClose = (data?: any) => {
  try {
    Mixpanel.track('Promo HighlightBanner Closed', { ...data })
  } catch (error) {
    console.log('Error in mixpanel', error)
  }
}

const onAdminExternalIntegrationDialogOpened = (data?: any) => {
  try {
    Mixpanel.track('Admin external integration dialog opened', { ...data })
  } catch (error) {
    console.log('Error in mixpanel', error)
  }
}

const onSchoolMailPageView = (data?: any) => {
  try {
    Mixpanel.track('School Mail page view', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onMailHistoryPageView = (data?: any) => {
  try {
    Mixpanel.track('Mail History page view', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminApproveStudentAttempt = (data?: any) => {
  try {
    Mixpanel.track('on admin commission approve student attempt', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminCommissionApproveStudentAttempt = (data?: any) => {
  try {
    Mixpanel.track('on admin commission approve student attempt', { ...data })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onAdminSubscriptionApproveStudentAttempt = (data?: any) => {
  try {
    Mixpanel.track('on admin subscription approve student attempt', {
      ...data,
    })
  } catch (e) {
    console.log('Error in mixpanel', e)
  }
}

const onContentAppsSelected = (data?: any) => {
  try {
    Mixpanel.track('Content Apps Selected', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

const onShowStudentResultChecked = (data?: any) => {
  try {
    Mixpanel.track('Show Student Result Checked', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

const onShowEnableQuizOnHomepageChecked = (data?: any) => {
  try {
    Mixpanel.track('Show enable quiz on homepage', { ...data })
  } catch (error) {
    console.log('Error in Mixpanel')
  }
}

export const AnalyticService = {
  onAdminCreateCourseClicked,
  onAdminCourseClicked,
  onAdminCourseDetailsSubmitted,
  onAdminCourseCreated,
  onAdminCourseShareClicked,
  onAdminCourseStudentsClicked,
  onAdminCreateCourseClosed,
  onAdminCourseSettingClicked,
  onAdminExternalIntegrationDialogOpened,

  onAdminCreateCourseContentClicked,
  onAdminCreateCourseLessonClicked,
  onAdminCourseContentCreatedSuccess,
  onAdminCourseLessonCreatedSuccess,

  onAdminCourseTemplateOpened,
  onAdminCourseTemplatePreview,
  onAdminCourseTemplateClosed,
  onAdminCourseTemplateSelected,

  onUserSignup,
  onUserLogin,
  onAdminLoginSelected,
  onAdminSignupSelected,
  onAdminLoginError,
  onAdminSignupError,

  onAdminCreateSchoolClicked,
  onAdminDashboardViewed,
  onAdminSchoolClicked,
  onAdminSchoolCreatedSuccess,

  onAdminUpgradeSchoolSubscriptionPageView,
  onAdminUpgradeSchoolBillingPlanSelected,
  onAdminUpgradeSchoolSelected,
  onAdminUpgradeSchoolApplyDiscount,
  onAdminUpgradeSchoolSuccessful,
  onAdminHubspotDialogOpened,

  onAdminUserLogout,
  onSchoolUserLogout,
  onUserAutomatedLogout,

  identifyUser,
  onPledreHomepageVisit,
  onSchoolVisit,

  onCreatorSuiteSelected,
  onRecordVideoSelected,
  onVideoRecordingStarted,
  onVideoRecordingSuccessful,
  onVideoRecordingSaved,
  onUploadItemStarted,
  onUploadItemSuccessful,

  onCouponPageView,
  onCreateCouponClicked,
  onCouponCreatedSuccesfully,
  onViewCouponClicked,
  onEditCoupon,
  onDeleteCoupon,
  onCouponAppliedSuccessfully,

  onForgotPassword,
  onMyCourseClicked,
  openClassroomClicked,
  openCourseClicked,
  userDashboardViewed,
  assessmentClicked,
  assessmentViewed,
  assessmentAttemptClicked,
  assessmentAttempted,
  assessmentViewedClicked,
  activeChatClicked,
  activeChatViewed,
  searchForUser,
  userSelectedFromSearch,
  chatViewedForSchoolUser,
  chatTypingForSchoolUser,
  chatSent,
  forumDiscussionClicked,
  forumDiscussionViewed,
  createdDiscussionClicked,
  createdDiscussionViewed,
  publicDiscussionViewed,
  publishDiscussionClicked,
  publishDiscussionSuccessful,
  billingClicked,
  billingViewed,
  paymentInitiated,
  paymentSuccessful,
  scheduledViewed,
  scheduledClicked,
  viewCurriculum,
  classroomViewed,
  contentClicked,
  contentViewed,
  liveClassClicked,
  liveClassJoined,
  liveClassLeft,
  clickLeaveClass,
  liveClassInitiated,
  liveClassStarted,
  onCreateNewPassword,
  courseContentClicked,
  adminChangeSidebarContentClicked,
  dialogOpened,
  dialogClosed,
  toggleLiveClassDialog,
  liveClassRecordingClicked,
  liveClassToggleAttendees,
  liveClassToggleChat,
  liveClassSendChatMessage,
  liveClassStopMeetingClicked,
  liveClassRaiseHandClicked,
  onEditCourseContent,
  onAdminExpertFormClicked,
  onAdminDiscountFormClicked,
  onHighlightBannerClicked,
  onHighlightBannerClose,
  onSchoolMailPageView,
  onMailHistoryPageView,
  onAdminClusterShareClicked,
  onPledreSSOUse,
  onAdminApproveStudentAttempt,
  onAdminCommissionApproveStudentAttempt,
  onAdminSubscriptionApproveStudentAttempt,
  creatorSuiteRecordingStarted,
  creatorSuiteRecordingStopped,
  onContentAppsSelected,
  onImportYoutubeVideoSelected,
  onShowStudentResultChecked,
  onShowEnableQuizOnHomepageChecked,
}
